export const jp = {
    common: {
        home: 'ホーム',
        search: '検索',
        guest: 'ゲスト',
        logout: 'ログアウト',
        toggleTheme: 'テーマを切り替え',
        toggleSidebar: 'サイドバーを切り替え',
        close: '閉じる',
        more: 'もっと見る',
        saveChanges: '変更を保存',
        cancel: 'キャンセル',
        delete: '削除',
        export: 'エクスポート',
        loading: '読み込み中...',
        activity: 'アクティビティ',
        confirm: '確認',
        noResultsFound: '結果が見つかりませんでした。',
        justNow: 'たった今',
        minutesAgo: '{{count}}分前',
        hoursAgo: '{{count}}時間前',
        daysAgo: '{{count}}日前',
        pagination: {
            previous: '前へ',
            next: '次へ',
            page: '{{totalPages}}ページ中 {{page}}ページ',
            summary: '{{totalPages}}ページ中 {{page}}ページ · {{total}}件中{{count}}件を表示'
        }
    },
    notFound: {
        title: '404',
        heading: 'ページが見つかりません',
        description: 'お探しのページは存在しないか、移動されました。',
        cta: 'ダッシュボードへ移動'
    },
    routeError: {
        heading: '問題が発生しました',
        description: 'ページの読み込み中にルーターで予期しないエラーが発生しました。',
        cta: 'ダッシュボードに戻る'
    },
    startup: {
        preparingSessionTitle: 'セッションを準備しています',
        preparingSessionDescription: 'アプリを表示する前に認証状態を確認しています。',
        preparingSessionStatus: '認証を確認しています',
        loadingDataTitle: '起動データを読み込んでいます',
        loadingDataDescription: 'アプリに必要なアカウント情報と組織コンテキストを取得しています。',
        loadingDataStatus: '起動データを読み込んでいます',
        waitHint: '起動が完了するまでこの画面を表示し、保護されたナビゲーションが先に見えないようにします。',
        errorTitle: '起動を完了できませんでした',
        errorDescription: '回復可能な起動リクエストが失敗しました。ページ全体を再読み込みせずに再試行できます。',
        errorFallback: '予期しない起動エラーが発生しました。',
        retry: '起動を再試行',
        retryHint: '解決しない場合は、バックエンド接続と認証状態を確認してください。'
    },
    appShell: {
        onboardingCheck: {
            failureTitle: 'オンボーディングをまだ確認できません',
            failureDescription: '組織のオンボーディング確認を再試行している間、操作は一時停止されたままです。',
            retry: 'オンボーディング確認を再試行'
        }
    },
    dashboardWelcome: {
        badge: '初回ダッシュボードへようこそ',
        title: '準備できました。チェックアウト後のスキャフォールドです。',
        description:
            '新しい組織向けのフロントエンド限定モックのダッシュボード状態です。実際の API キー作成、スターターテンプレート、ライブコンソール出力は後で追加されます。',
        continueAction: '組織へ進む',
        apiKeyTitle: 'API キーのスキャフォールド',
        apiKeyDescription:
            '最初のプロジェクトキー、スコープ、コピー操作、最終使用メタデータ用のプレースホルダーカードです。',
        primaryKey: 'プライマリキー',
        createApiKey: 'API キーを作成',
        quickstartTitle: 'クイックスタートのスキャフォールド',
        quickstartDescription:
            'デフォルトタブはオンボーディングのビルドモードに従います。スニペットは現時点ではモックのプレースホルダーです。',
        recommendedTemplateTitle: 'おすすめテンプレート',
        recommendedTemplateDescription:
            'オンボーディングの目標とビルドモードに基づくテンプレート提案用のプレースホルダー領域です。',
        starterPipelineTitle: 'スターターコンテンツパイプライン',
        starterPipelineDescription:
            '提案された設定カード、スタータープロンプト、事前入力されたソース連携がここに表示されます。',
        applyTemplate: 'テンプレートを適用',
        consoleTitle: 'コンソール / レスポンス領域',
        consoleDescription: 'SDK レスポンス、リクエストトレース、最初の成功出力用のプレースホルダーです。',
        consoleStatus: 'ステータス: ライブバックエンド連携を待機中…',
        consoleReady: 'モックレスポンスパネルの準備ができました'
    },
    home: {
        title: 'ホーム',
        unlimited: '無制限',
        apiUsage: '// API 使用量',
        publishJobsPerDay: '1 日あたりの公開ジョブ',
        last7Days: '過去 7 日間',
        jobsOnDate: '{{date}} の公開ジョブ: {{count}} 件',
        noJobsLast7Days: '過去 7 日間に公開ジョブはありません',
        usageUnavailable: '使用量データを利用できません',
        postsUsed: '@{{account}} · {{used}} / {{limit}} 件使用済み',
        resetsOn: '{{date}} にリセット',
        noQuotaPeriod: 'クォータ期間なし',
        gettingStarted: '// はじめに',
        recentJobs: '// 最近のジョブ',
        loadingRecentJobs: '最近のジョブを読み込み中…',
        recentJobsUnavailable: '最近のジョブを利用できません。',
        noPublishingJobs: '公開ジョブはまだありません。',
        untitledPost: '無題の投稿',
        activeKeyCount: '有効な API キー {{count}} 件',
        loadingDescription: '組織の概要を読み込み中…',
        stats: {
            connectedAccounts: '接続済みアカウント',
            sourcesInPlan: 'プランに {{count}} 個のソースが含まれます',
            postsLeft: '今期間の残り投稿数',
            postsAcrossAccounts: '接続済みアカウント全体で {{count}} 件',
            scheduledJobs: '予約済みジョブ'
        },
        checklist: {
            createOrganization: '組織を作成',
            connectSocialAccount: 'ソーシャルアカウントを接続',
            socialAccountDetail: 'Instagram または X',
            createApiKey: 'API キーを作成',
            apiKeyScopes: 'publishing:read · publishing:publish',
            publishFirstPost: '最初の投稿を公開',
            publishEndpoint: 'POST /publishing/jobs'
        },
        actions: {
            createPost: '投稿を作成',
            start: '開始',
            viewAll: 'すべて表示',
            viewApiDocs: 'API ドキュメントを見る',
            createApiKey: 'API キーを作成',
            connectAccount: 'アカウントを接続',
            viewInsights: 'インサイトを見る',
            inviteMember: 'メンバーを招待'
        },
        quickActions: '// クイックアクション',
        quickActionsTitle: '組織とともに構築',
        quickActionsDescription: 'ワークスペースに接続済みのツールから始めましょう。',
        status: { published: '公開済み', processing: '処理中', scheduled: '予約済み', other: '不明' }
    },
    settings: {
        pageTitle: '設定',
        pageDescription: '組織の設定と基本設定を管理します。',
        general: '一般',
        notifications: '通知',
        danger: '危険ゾーン',
        billing: {
            tab: '請求',
            title: '請求',
            description: '{{organizationName}} の現在の請求状態を確認します。',
            currentPlanEyebrow: '// 現在のプラン',
            entitlementsEyebrow: '// 利用権限',
            noOrganizationTitle: '組織が選択されていません',
            noOrganizationDescription:
                'サブスクリプションと請求の詳細を表示するには、組織を選択するか作成してください。',
            portalFooter: '請求は Stripe 経由です。カードと請求書はカスタマーポータルで管理できます。',
            lifetimeBadge: 'ライフタイム',
            lifetimeFooter:
                'この組織はライフタイムプランを利用しており、Stripe 経由での請求はありません。管理するカードや請求書もありません。プランを変更する場合は invisibleapi までご連絡ください。',
            cancelAtPeriodEndNotice: 'このサブスクリプションは現在の請求期間の終了時にキャンセルされる設定です。',
            manageBillingDisabledNoOrganization: '先に組織を作成するか選択してください。',
            manageBillingDisabledNoCustomer: 'この組織にはまだ Stripe の顧客情報がありません。',
            manageBillingDisabledLifetime:
                'ライフタイムプランは Stripe 経由で請求されないため、カスタマーポータルはありません。',
            priceAfterTrialValue: '{{price}}/{{interval}}',
            postsLimitValue: '接続済みアカウントごと・期間ごとに {{count}} 件の投稿。',
            noActivePlanTitle: '有効なプランなし',
            capabilitiesTitle: '機能',
            limitsTitle: '制限',
            emptyBillingState: '選択中の組織では、まだ請求状態を利用できません。',
            emptyCapabilities: '機能データが返されませんでした。',
            emptyLimits: '制限データが返されませんでした。',
            fields: {
                subscriptionStatus: 'サブスクリプションの状態',
                billingInterval: '請求間隔',
                quantity: 'ソース数',
                priceAfterTrial: 'トライアル後の価格',
                trialEndsAt: 'トライアル終了',
                currentPeriod: '現在の期間',
                accessPeriod: '利用期間',
                cancelAtPeriodEnd: '期間終了時にキャンセル'
            },
            subscriptionStatuses: {
                active: '有効',
                trialing: 'トライアル中',
                incomplete: '未完了',
                incomplete_expired: '未完了（期限切れ）',
                past_due: '支払い遅延',
                canceled: 'キャンセル済み',
                unpaid: '未払い',
                paused: '一時停止中'
            },
            billingIntervals: {
                monthly: '月額',
                yearly: '年額'
            },
            boolean: {
                yes: 'はい',
                no: 'いいえ'
            },
            errors: {
                generic: '請求データを読み込めませんでした。'
            },
            checkout: {
                loading: 'リダイレクトしています…'
            },
            customerPortal: {
                open: '請求を管理',
                loading: 'ポータルを開いています…'
            },
            returnState: {
                success: '請求チェックアウトが完了しました。請求状態を更新しています…',
                cancel: '請求チェックアウトはキャンセルされました。',
                portalReturn: '請求ポータルから戻りました。請求状態を更新しています…'
            }
        },
        generalTitle: '一般設定',
        generalDescription: '組織名と基本設定を構成します。',
        workspaceName: '組織名',
        workspaceSlug: '組織スラッグ',
        timezone: 'タイムゾーン',
        settingsSaved: '設定を保存しました',
        notificationsSaved: '通知設定を保存しました',
        notificationsTitle: '通知設定',
        notificationsDescription: '通知を受け取る方法とタイミングを選択します。',
        emailNotifications: 'メール通知',
        emailNotificationsDescription: '組織のアクティビティに関する更新をメールで受け取ります。',
        pushNotifications: 'プッシュ通知',
        pushNotificationsDescription: '重要なイベントをブラウザで通知します。',
        weeklyDigest: '週間ダイジェスト',
        weeklyDigestDescription: '組織のアクティビティの週間サマリーを受け取ります。',
        dangerTitle: '危険ゾーン',
        dangerDescription: '組織に影響する取り消し不能な操作。',
        deleteWorkspace: '組織を削除',
        deleteWorkspaceDescription: 'この組織とそのすべてのデータを完全に削除します。',
        deleteUnavailable: 'この操作はテンプレートでは利用できません。',
        exportData: 'データをエクスポート',
        exportDataDescription: '組織データの完全なエクスポートをダウンロードします。',
        exportStarted: 'エクスポートを開始しました。準備ができたら通知されます。',
        savePreferences: '設定を保存'
    },
    accountDetails: {
        pageTitle: 'アカウント詳細',
        pageDescription: 'プロフィール情報とアカウントのセキュリティ操作を管理します。',
        loadErrorTitle: 'アカウント詳細を読み込めませんでした',
        retry: '再試行',
        managedBadge: '一元管理',
        readOnlyBadge: '読み取り専用',
        emptyValue: '未設定',
        fields: {
            firstName: '名',
            lastName: '姓',
            username: 'ユーザー名',
            email: 'メール'
        },
        personalInfo: {
            title: '個人情報',
            description: 'このアカウントで編集可能なプロフィール項目を更新します。',
            sourceHint: 'ユーザー名とメールはサインインの本人確認データから取得されるため、ここでは編集できません。',
            saving: '保存しています...',
            reset: '変更をリセット',
            saveSuccessToast: 'アカウント詳細を保存しました。',
            validationErrorToast: '強調表示された項目を確認して、もう一度お試しください。'
        },
        security: {
            title: '認証とセキュリティ',
            description:
                'バックエンド操作を通じてアカウントのセキュリティフローを開始します。管理者アクセスがブラウザに渡ることはありません。',
            emailFlowBadge: 'セキュアメールフロー',
            password: {
                title: '基本認証',
                description: 'パスワード更新メールを自分に送信し、安全なメールフローから変更を完了します。',
                methodLabel: 'パスワード更新方法',
                methodValue: '安全なメールフロー',
                action: 'パスワード更新メールを送信',
                sending: 'メールを送信しています...',
                successToast: 'パスワード更新メールをリクエストしました。受信トレイを確認してください。',
                successInline: 'メールをリクエストしました。パスワード更新フローのため受信トレイを確認してください。'
            },
            twoFactor: {
                title: '二要素認証',
                description: '設定メールを自分に送信し、そのフローから認証アプリを設定します。',
                methodLabel: '二要素設定方法',
                methodValue: '安全なメールフロー',
                action: '二要素設定メールを送信',
                sending: 'メールを送信しています...',
                successToast: '二要素設定メールをリクエストしました。受信トレイを確認してください。',
                successInline: 'メールをリクエストしました。二要素設定フローのため受信トレイを確認してください。'
            }
        }
    },
    sidebar: {
        appName: 'SaaS アプリ',
        workspace: '組織',
        login: 'ログイン',
        logout: 'ログアウト',
        signedIn: 'サインイン済み',
        openSignIn: 'サインインを開く',
        account: 'アカウント',
        accountDetails: 'アカウント詳細',
        organizationMenu: '組織',
        organizations: '組織',
        currentOrganization: '現在',
        noOrganization: 'まだ組織がありません',
        language: '言語',
        languageSelector: '言語を選択',
        languages: {
            en: '英語',
            de: 'ドイツ語',
            es: 'スペイン語',
            fr: 'フランス語',
            mk: 'マケドニア語',
            jp: '日本語'
        }
    },
    nav: {
        home: 'ホーム',
        organizations: '組織',
        socialAccounts: 'ソーシャルアカウント',
        members: 'メンバー',
        invitations: '招待',
        publishing: '公開',
        insights: 'インサイト',
        apiKeys: 'API キー',
        apiDocs: 'API ドキュメント',
        settings: '設定',
        pricing: '料金',
        content: 'コンテンツ',
        audience: 'オーディエンス',
        advancedQuery: '詳細クエリ',
        main: 'メイン'
    },
    publishing: {
        pageTitle: '公開',
        pageDescription: '{{organizationName}} の公開ジョブと最新の配信状況を確認します。',
        emptyOrganizationDescription: '公開ジョブを確認するには、組織を選択するか新しく作成してください。',
        empty: '公開ジョブはまだありません。',
        refreshAction: 'ジョブを再読み込み',
        refreshDescription: 'サーバーから最新の公開ジョブを再取得します。',
        deliveryRecordsTitle: '配信レコードの意味',
        deliveryRecordsDescription:
            '各配信レコードは、選択したソーシャルアカウントに対するプラットフォームごとの配信試行または結果を表します。ターゲットごとに何が起きたかを確認するために使います。',
        scheduledFor: '{{value}} に予約済み',
        pagination: {
            previous: '前へ',
            next: '次へ',
            page: '{{page}}ページ',
            summary: '{{page}}ページ目 · {{count}}件のジョブを表示中（1ページ最大{{perPage}}件）',
            summaryCompact: '{{count}} 件 · {{page}} / {{totalPages}} ページ'
        },
        emptyStateTitle: '公開ジョブはまだありません',
        createAction: '投稿を作成',
        subscriptionInactiveDescription:
            'この組織のサブスクリプションが更新されるまで、新しい投稿と失敗したジョブの再試行は停止されます。',
        previewAction: 'プレビュー',
        previewPostAction: '投稿プレビュー',
        actionsMenuLabel: 'アクションメニューを開く',
        technicalDetailsAction: '技術詳細',
        technicalDetailsTitle: '公開ジョブの技術詳細',
        technicalDetailsDescription: 'このジョブの生の公開ペイロードと配信詳細を確認します。',
        previewTitle: '公開ジョブのプレビュー',
        previewDescription: 'この公開ジョブの最新の保存状態を確認します。',
        previewLoading: '公開ジョブの詳細を読み込み中…',
        instagram: {
            follow: 'フォロー',
            mediaAlt: 'Instagramプレビュー用メディア',
            multiAsset: '{{count}}件',
            commentPlaceholder: 'コメントを追加…',
            justNow: 'たった今'
        },
        noCaption: 'キャプションはありません。',
        noMediaItems: 'この公開ジョブにはメディア項目が添付されていません。',
        noDeliveries: 'この公開ジョブにはまだ配信記録がありません。',
        failureTitle: '失敗の詳細',
        mediaItemsCount: '{{count}} 件のメディア項目',
        deliveriesCount: '{{count}} 件の配信記録',
        columns: {
            status: 'ステータス',
            caption: 'キャプション',
            targets: '配信',
            createdAt: '作成日時',
            publishedAt: '公開日時',
            actions: '操作',
            actionsDescription: 'その公開ジョブのプレビュー／詳細画面を開きます。'
        },
        fields: {
            status: 'ステータス',
            createdAt: '作成日時',
            updatedAt: '更新日時',
            publishedAt: '公開日時',
            caption: 'キャプション',
            firstComment: '最初のコメント',
            requestedPublishAt: '予定日時',
            mediaItems: 'メディア項目',
            captionHelp: '簡潔で各プラットフォーム向けに整えた内容にしてください。送信前にすべて確認できます。',
            firstCommentHelp: '任意です。対象プラットフォームが対応している場合、本文の後に投稿されます。',
            mediaType: 'メディアタイプ',
            sourceUrl: '元URL',
            publicFetchUrl: '公開取得URL',
            altText: '代替テキスト',
            deliveries: '配信',
            failureCode: '失敗コード',
            failureMessage: '失敗メッセージ'
        },
        status: {
            pending: '保留中',
            queued: 'キュー待ち',
            scheduled: '予約済み',
            processing: '処理中',
            published: '公開済み',
            failed: '失敗',
            canceled: 'キャンセル済み'
        }
    },

    publishingComposer: {
        pageTitle: '投稿を作成',
        pageDescription: '{{organizationName}} 向けの公開ジョブを作成し、公開ワークフローに送信します。',
        backToList: '公開一覧に戻る',
        emptyOrganizationTitle: '組織が選択されていません',
        emptyOrganizationDescription: '公開ジョブを作成する前に、組織を選択するか新しく作成してください。',
        publishTimeHint: 'この投稿を今すぐ公開するか、ローカル時間で予約して公開するかを選択してください。',
        localTimezoneHint: '予約時刻には現在のローカルタイムゾーンが使用されます。',
        connectAccountsAction: 'ソーシャルアカウントを開く',
        platformHint:
            'この投稿をどこに公開するかを選択してください。Instagram と X は、利用可能なアクティブ接続済みアカウントがある場合に公開できます。',
        socialAccountHint: 'この投稿を受け取る接続済みソーシャルアカウントを選択してください。',
        socialAccountAutoSelected: '利用可能な接続済みアカウントが 1 つだけのため、自動で選択されました。',
        selectSocialAccountAction: 'ソーシャルアカウントを選択',
        selectedAccountsSummary: '{{count}} 件のアカウントを選択中',
        selectedPlatformsLabel: '公開先',
        limits: {
            checking: '公開利用状況を確認しています…',
            remaining: 'この期間に残り{{count}}件投稿できます',
            exhausted: 'この期間の上限に達しました',
            exhaustedWithReset: '上限に達しました。{{resetAt}}にリセットされます',
            selectedExhaustedWarning: '{{account}} の公開可能数は残っていません。{{resetAt}}にリセットされます。',
            selectedExhaustedWarningNoReset: '{{account}} の公開可能数は残っていません。',
            unavailable:
                '現在、公開利用状況を取得できません。公開は続行できます。送信時にバックエンド側で上限が確認されます。'
        },
        noEligibleAccountsTitle: '利用可能な公開アカウントがありません',
        noEligibleAccountsDescription: '投稿を作成する前に Instagram または X のアカウントを接続してください。',
        noHandle: '公開ハンドルはありません',
        selectedBadge: '選択済み',
        notSelectedBadge: '未選択',
        comingSoon: '近日公開',
        additionalMediaItemsTitle: '追加のメディア項目',
        additionalMediaItemsDescription: 'カルーセル投稿、X 投稿、動画のために保持されます。',
        mediaPublicUrlHint: 'メディアは公開 URL として送信されます。',
        noAccountsBadge: 'アカウントなし',
        mediaStepHint: 'この投稿のメディア詳細とキャプションを追加してください。',
        textOnlyHint: 'X のテキスト投稿は、メディア項目なしでキャプションを送信します。',
        instagramNoImageHint: '画像をアップロードしない場合、この投稿は Instagram には公開されません。',
        mediaItemsTitle: 'メディア項目',
        mediaItemsHint: 'この投稿にメディアを含める場合は、1 件以上の画像または動画を追加してください。',
        multiMediaBadge: '{{count}} 件のメディア',
        addMediaAction: '投稿にメディアを追加',
        removeMediaAction: '削除',
        mediaItemTitle: 'メディア項目 {{index}}',
        publicFetchUrlMirrorsSourceHint:
            'バックエンドは sourceUrl を必須としています。このフィールドは送信時に sourceUrl と publicFetchUrl の両方に使われます。',
        altTextPlaceholder: 'このメディア項目のアクセシブルな説明',
        captionPlaceholder: '投稿のキャプションを入力…',
        submitAction: '投稿を公開',
        scheduleSubmitAction: '投稿を予約',
        subscriptionInactiveDescription:
            '新しい公開ジョブを作成する前に、この組織のサブスクリプションを更新してください。',
        stepCompleteBadge: '完了',
        submitting: '公開しています...',
        successToast: '公開ジョブを作成しました。',
        successToastScheduled: '公開ジョブを予約しました。',
        livePreviewTitle: 'ライブプレビュー',
        livePreviewDescription: '作成中に投稿を確認したり、全画面で開いたりできます。',
        fullscreenPreviewAction: '全画面',
        selectDateAction: '日付を選択',
        previewAccountPlaceholder: '選択したソーシャルアカウント',
        previewHandlePlaceholder: '@account',
        previewMediaPlaceholder: 'メディアプレビュー',
        previewCaptionPlaceholder: '入力中のキャプションがここに表示されます。',
        previewAdditionalMediaCount: '+{{count}} 件追加',
        previewScheduledBadge: '予約済み',
        videoPreviewLabel: '動画プレビュー',
        twitterPreviewComingSoon: 'Twitter/Xプレビューでは、選択したXアカウントと投稿内容を使用します。',
        postPublishingTitle: '投稿の公開',
        stepFlowTitle: 'ステップごとのコンポーザー',
        stepFlowDescription:
            '各ブロックを順番に完了してください。前のブロックが完了するまで次のブロックはロックされます。',
        publishModes: {
            now: '今すぐ公開',
            nowDescription: '送信後すぐに公開ワークフローを開始します。',
            scheduled: '後で予約する',
            scheduledDescription: 'この投稿を将来の日時に予約します。'
        },
        platforms: {
            instagram: 'Instagram',
            twitter: 'Twitter / X'
        },
        steps: {
            socialAccounts: 'ソーシャルアカウント',
            targets: '公開先',
            publishingTime: '公開タイミング',
            postContent: '投稿内容'
        },
        fields: {
            platform: '対象プラットフォーム',
            socialAccount: 'ソーシャルアカウント',
            mediaItems: 'メディア項目',
            mediaUrl: 'メディアURL',
            captionHelp: '簡潔で各プラットフォーム向けに整えた内容にしてください。',
            mediaType: 'メディアタイプ',
            sourceUrl: '元URL',
            publicFetchUrl: '公開取得URL',
            altText: '代替テキスト',
            caption: 'キャプション',
            requestedPublishAt: '予定日時',
            scheduleDate: '日付',
            publishTime: '公開時間',
            publishAtLocalTime: '公開日時（ローカル時間）',
            scheduleTime: '時刻'
        },
        placeholders: {
            primaryMediaUrl: 'https://cdn.yourapp.com/photo.jpg',
            additionalMediaUrl: 'https://cdn.example.com/post-image.jpg'
        },
        mediaTypes: {
            text: 'テキストのみ',
            image: '画像',
            video: '動画'
        },
        validation: {
            generic: '公開フォームを確認し、強調表示された項目を修正してください。',
            socialAccountRequired: '続行する前にソーシャルアカウントを選択してください。',
            platformRequired: '利用可能な公開先プラットフォームを選択してください。',
            mediaItemRequired: '選択したプラットフォーム向けに少なくとも1件のメディア項目を追加してください。',
            mediaTypeInvalid: 'テキストのみの投稿はXでのみ利用できます。',
            publishModeRequired: '続行する前に公開タイミングを選択してください。',
            captionRequired: 'キャプションは必須です。',
            publicFetchUrlRequired: '公開取得URLは必須です。',
            publicFetchUrlInvalid: '公開取得URLは有効なURLである必要があります。',
            xCarouselImagesOnly:
                'X のカルーセル投稿は画像のみ対応しています。動画は単一メディア投稿として X に公開してください。',
            xCarouselImageCount: 'X のカルーセル投稿は最大 {{count}} 枚の画像まで対応しています。',
            requestedPublishAtRequired: '予約する日時を選択してください。',
            requestedPublishAtInvalid: '予約する日時は有効である必要があります。',
            requestedPublishAtFuture: '予約する日時は未来の時刻である必要があります。'
        }
    },

    insights: {
        pageTitle: 'Instagram インサイト',
        pageDescription: 'アカウントと日付範囲を選択してください。ページはこの 2 つのフィルターに応じて更新されます。',
        emptyOrganizationDescription: 'Instagram インサイトを表示するには、組織を選択または作成してください。',
        accountPickerLabel: 'Instagram アカウント',
        accountPickerPlaceholder: 'アカウントを選択',
        noInsightsAccounts:
            'インサイトに対応した Instagram アカウントはまだ接続されていません。Instagram プロアカウントを接続して開始してください。',
        noInsightsAccountsHelp:
            'インサイトアクセスのある Instagram アカウントを接続すると、概要指標、オーディエンス属性、コンテンツ内訳を利用できます。',
        subscriptionInactiveTitle: 'インサイトは停止中です',
        subscriptionInactiveDescription:
            'この組織のサブスクリプションが無効な間、Instagram インサイトの更新は停止されます。',
        subscriptionInactiveHelp: 'サブスクリプションを更新すると、新しいインサイトデータを再取得できます。',
        connectAccountCta: 'ソーシャルアカウントへ移動',
        dateRangeLabel: '日付範囲',
        dateRange: {
            last7Days: '過去 7 日間',
            last14Days: '過去 14 日間',
            last30Days: '過去 30 日間'
        },
        overviewTitle: '概要',
        tabs: {
            overview: '概要',
            content: 'コンテンツ内訳',
            trend: 'トレンド',
            breakdowns: '内訳',
            audience: 'オーディエンス',
            advanced: '詳細クエリ'
        },
        currentViewLabel: '現在の表示',
        currentViewTitle: 'Instagram アカウントインサイト',
        currentViewDescription:
            '概要カードに主要な数値が表示されます。下のタブでトレンド、内訳、オーディエンス、未加工クエリ探索を確認できます。',
        trendTitle: 'リーチの推移',
        trendTitleWithMetric: '{{metric}} の推移',
        trendDescription: '選択した範囲で 1 日ごとにリーチしたユニークアカウント数です。',
        trendTracking: '選択した範囲で {{metric}} を追跡しています。',
        chartValueLabel: '値',
        overviewSectionPrimaryLabel: '// 主要',
        overviewSectionEngagementLabel: '// エンゲージメント',
        quickSegmentTitle: 'セグメントのクイック概要',
        quickSegmentDescription: 'アクティブな指標で最も強いコンテンツ内訳を素早く確認します。',
        topSegment: '上位セグメント',
        topAudience: '上位オーディエンス',
        rankTop: 'トップ',
        primaryMetricBadge: '主要',
        metricHelpLabel: '{{metric}} のヘルプ',
        filtersBadge: 'Instagram インサイト',
        filtersTitle: 'ダッシュボードを絞り込む',
        filtersDescription:
            'アカウントと日付範囲を選択してください。この 2 つのフィルターに合わせてページが更新されます。',
        filtersAction: 'フィルター',
        filtersSheetTitle: 'インサイトフィルター',
        filtersSheetDescription: 'ダッシュボードのアカウントと日付範囲を調整します。',
        breakdownTitle: '指標の内訳',
        breakdownDescription: '指標の合計を対応するディメンションで分割します。',
        breakdownMetricLabel: '指標',
        breakdownDimensionLabel: '内訳',
        breakdownColumns: {
            rank: 'ランク',
            dimension: 'ディメンション',
            value: '値',
            share: '割合'
        },
        breakdownTotal: '合計: {{value}}',
        audienceTitle: 'オーディエンス属性',
        audienceDescription: 'このアカウントをフォローし、エンゲージしているユーザーです。',
        audienceMetricLabel: 'オーディエンス',
        audienceMetrics: {
            follower_demographics: 'フォロワー',
            engaged_audience_demographics: 'エンゲージしたオーディエンス'
        },
        audienceBreakdownLabel: 'グループ化',
        audienceBreakdowns: {
            country: '国',
            city: '都市',
            age: '年齢',
            gender: '性別'
        },
        audienceTimeframeLabel: '期間',
        audienceTimeframes: {
            this_week: '今週',
            this_month: '今月'
        },
        advancedTitle: '詳細クエリ',
        advancedDescription: 'Instagram インサイト API にカスタムクエリを送信し、未加工レスポンスを確認します。',
        advancedExplorerDescription:
            'このエクスプローラーは補助的なものです。エッジケースの指標、未対応の内訳、未加工 API ペイロードの検証に使用してください。',
        advancedBadges: {
            rawApiQueryBuilder: '未加工 API クエリビルダー',
            debugFirst: 'デバッグ優先'
        },
        advancedMetricLabel: '指標（カンマ区切り）',
        advancedMetricPlaceholder: 'reach',
        advancedPeriodLabel: '期間',
        advancedMetricTypeLabel: '指標タイプ',
        advancedBreakdownLabel: '内訳',
        advancedBreakdownPlaceholder: 'media_product_type',
        advancedTimeframeLabel: '期間',
        advancedSinceLabel: '開始',
        advancedUntilLabel: '終了',
        advancedRun: 'クエリを実行',
        advancedNone: 'なし',
        advancedPeriods: {
            day: '日',
            week: '週',
            days_28: '28 日間',
            lifetime: '全期間'
        },
        advancedMetricTypes: {
            total_value: '合計値',
            time_series: '時系列'
        },
        rawResponseTitle: '未加工レスポンス',
        metrics: {
            reach: 'リーチ',
            accounts_engaged: 'エンゲージしたアカウント',
            total_interactions: '合計インタラクション',
            likes: 'いいね',
            comments: 'コメント',
            shares: 'シェア',
            saves: '保存',
            views: 'ビュー',
            follows_and_unfollows: 'フォローとフォロー解除',
            profile_links_taps: 'プロフィールリンクのタップ'
        },
        metricDescriptions: {
            reach: '選択した範囲でアカウントのコンテンツを見たユニークアカウント数です。',
            accounts_engaged: 'アカウントのコンテンツに反応したユニークアカウント数です。',
            total_interactions: '対応しているエンゲージメント操作全体の合計インタラクションです。',
            default: 'アカウントレベルの概要インサイト指標です。'
        },
        breakdownDimensions: {
            REELS: 'リール',
            POSTS: '投稿',
            STORIES: 'ストーリーズ',
            CAROUSEL_CONTAINER: 'カルーセル投稿',
            FOLLOWER: 'フォロワー',
            NON_FOLLOWER: '非フォロワー',
            FOLLOWERS: 'フォロワー',
            NON_FOLLOWERS: '非フォロワー',
            MEDIA_PRODUCT_TYPE: 'メディア商品タイプ',
            FOLLOW_TYPE: 'フォロータイプ',
            CONTACT_BUTTON_TYPE: '連絡ボタンタイプ',
            THIS_WEEK: '今週',
            THIS_MONTH: '今月',
            UNKNOWN: '不明',
            M: '男性',
            F: '女性',
            U: '不明'
        },
        noData: 'このクエリではデータが返されませんでした。',
        retry: '再試行',
        unknownError: '不明なエラー'
    },
    apiDocs: {
        pageTitle: 'API ドキュメント',
        pageDescription: 'クイックスタート、エンドポイント一覧、埋め込み API ドキュメントを 1 か所にまとめました。',
        openFullDocumentation: '完全なドキュメントを開く',
        subscriptionInactiveDescription:
            'サブスクリプションアクセスが無効な間は組織の API キーが停止されるため、請求が更新されるまでこの組織に対する認証済み API リクエストは失敗します。',
        shell: {
            defaultDocsLocaleLabel: 'デフォルト',
            fallbackNotice:
                'フロントエンド言語 {{frontendLanguage}} 専用のドキュメント成果物が存在しないため、このページは {{docsLanguage}} にフォールバックしました。',
            organizationIdLabel: 'アクティブな組織 ID',
            organizationIdDescription:
                'API エンドポイントでアクティブな組織のパスパラメータが必要な場合は、この ID を使用してください。',
            copyOrganizationId: '組織 ID をコピー',
            organizationIdCopied: '組織 ID をコピーしました。',
            noActiveOrganizationId: 'アクティブな組織が選択されていません。',
            iframeRegionLabel: 'API ドキュメント埋め込みコンテナ',
            iframeTitle: '{{language}} 向けの埋め込み API ドキュメント',
            loadErrorTitle: 'ドキュメントマニフェストを読み込めませんでした',
            loadErrorDescription: 'ドキュメントマニフェストを読み込めませんでした: {{error}}',
            loadErrorFallback: '不明なドキュメントマニフェストエラーです。',
            noDocsTitle: '生成されたドキュメント成果物が見つかりません',
            noDocsDescription:
                'ドキュメントマニフェストは読み込まれましたが、埋め込み可能な生成済み静的ドキュメントページはありませんでした。'
        }
    },
    socialAccounts: {
        pageTitle: 'ソーシャルアカウント',
        loadingDescription: 'ソーシャルアカウントを読み込み中...',
        pageDescription: '組織に接続されたソーシャルアカウントを管理します。',
        subscriptionInactiveDescription:
            'この組織のサブスクリプションが更新されるまで、ソーシャルアカウントの追加や再接続は停止されます。',
        sourceLimit: {
            title: 'ソース上限に達しました',
            description:
                'この組織は購入済みソース {{limit}} 件中 {{used}} 件を使用しています。別のアカウントを接続する前にソースを追加購入してください。',
            actionBlockedToast:
                'ソース上限に達しました。別のソーシャルアカウントを接続する前にソースを追加購入してください。',
            checking: 'ソース上限を確認中…',
            unavailable: 'ソース上限を再確認できるまで、新しいアカウントの接続は停止されます。',
            unavailableTitle: 'ソース上限を確認できませんでした',
            unavailableRetry: '確認を再試行',
            manageBillingAction: '請求を管理',
            ownerHint: '組織のオーナーまたは管理者にソースの追加購入を依頼してください。'
        },
        searchPlaceholder: 'ソーシャルアカウントを検索',
        rowsPerPage: '1ページあたりの行数',
        empty: 'ソーシャルアカウントが見つかりません。',
        table: {
            title: '接続済みアカウント',
            totalCount: '合計 {{count}} アカウント'
        },
        columns: {
            id: 'ID',
            accountName: 'アカウント名',
            type: '種別',
            status: 'ステータス',
            actions: '操作',
            actionsDescription: 'その公開ジョブのプレビューまたは詳細表示を開きます。'
        },
        actions: {
            copyId: 'IDをコピー',
            refresh: '再接続',
            reconnect: '再接続',
            delete: '切断'
        },
        types: {
            instagram: 'Instagram',
            x: 'X'
        },
        statuses: {
            active: '接続済み',
            degraded: '劣化',
            reauthorization_required: '再接続が必要',
            disconnected: '切断済み',
            error: 'エラー'
        },
        pagination: {
            previous: '前へ',
            next: '次へ',
            page: '{{totalPages}} ページ中 {{page}} ページ',
            summary: '{{total}} 件中 {{start}}-{{end}} 件を表示',
            summaryCompact_one: '{{count}} 件 · {{page}} / {{totalPages}} ページ',
            summaryCompact_other: '{{count}} 件 · {{page}} / {{totalPages}} ページ'
        },
        connectDialog: {
            trigger: '新しいアカウントを追加',
            title: 'ソーシャルアカウントを接続',
            description: '接続するソーシャルソースを選択します。',
            liveBadge: '有効',
            comingSoonLabel: '// 近日公開',
            trustCopy: 'プラットフォームで直接認証します。パスワードは取得しません。',
            platforms: {
                instagram: {
                    name: 'Instagram',
                    requirement: 'Facebook ページにリンクされた Business または Creator アカウント。'
                },
                x: {
                    name: 'X',
                    requirement: '任意の X アカウント。'
                }
            },
            comingSoonPlatforms: {
                tiktok: 'TikTok',
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'YouTube'
            },
            connectInstagram: 'Instagram アカウントを接続',
            connectX: 'X アカウントを接続'
        },
        deleteDialog: {
            title: 'ソーシャルアカウントを切断',
            description: '"{{accountName}}" をこの組織から切断しますか？',
            success: 'ソーシャルアカウントを切断しました'
        },
        callback: {
            success: 'ソーシャルアカウントの接続に成功しました',
            error: 'ソーシャルアカウントの接続に失敗しました'
        },
        emptyOrganizationTitle: '組織が選択されていません',
        emptyOrganizationDescription: 'ソーシャルアカウントを管理する前に組織を選択してください。',
        errors: {
            missingAuthorization: 'このソーシャルアカウントに対して管理可能な認可が見つかりませんでした。'
        },
        idCopied: 'ソーシャルアカウントIDをコピーしました'
    },
    organizationMembers: {
        pageTitle: '組織メンバー',
        pageDescription: '{{organizationName}} のメンバーを管理します。',
        fallbackOrganizationName: '現在の組織',
        empty: 'この組織にはメンバーが見つかりません。',
        count: '{{count}} 人のメンバー · {{page}} / {{totalPages}} ページ',
        permissionHint: '現在の組織ロールではこのページを表示できますが、権限レベルによりメンバー管理操作は無効です。',
        genericMember: 'このメンバー',
        roleUpdated: 'メンバーのロールを更新しました',
        memberRemoved: 'メンバーを削除しました',
        removeAction: 'メンバーを削除',
        confirmRemoveTitle: '組織メンバーを削除',
        confirmRemoveDescription: '{{memberName}} をこの組織から削除しますか？この操作は UI から元に戻せません。',
        columns: {
            member: 'メンバー',
            role: 'ロール',
            joinedAt: '参加日',
            actions: '操作',
            actionsDescription: 'その公開ジョブのプレビューまたは詳細表示を開きます。'
        },
        roles: {
            owner: 'オーナー',
            admin: '管理者',
            member: 'メンバー',
            viewer: '閲覧者'
        },
        errors: {
            forbidden: 'そのメンバー操作を実行する権限がありません。',
            notFound: 'そのメンバーまたは組織が見つかりませんでした。',
            conflict: 'その変更は組織メンバーシップのルールに違反しています。',
            generic: 'メンバー操作に失敗しました。'
        }
    },
    organizationInvitations: {
        pageTitle: '組織への招待',
        pageDescription: '{{organizationName}} の招待を管理します。',
        fallbackOrganizationName: '現在の組織',
        empty: 'この組織には招待が見つかりません。',
        emptyDashedTitle: 'この組織には保留中の招待はまだありません。',
        count: '{{count}} 件の招待 · {{page}} / {{totalPages}} ページ',
        permissionHint: '現在の組織ロールでは招待を表示できますが、権限レベルにより招待の作成や取り消しは無効です。',
        inviteAction: 'チームメイトを招待',
        dialogTitle: 'チームメイトを招待',
        dialogDescription: '組織への招待を作成し、ワンタイムトークンをコピーします。',
        fields: {
            email: 'メールアドレス',
            role: 'ロール'
        },
        sendInvite: '招待を送信',
        inviting: '招待を作成しています...',
        invitationCreated: '招待を作成しました',
        invitationRevoked: '招待を取り消しました',
        revokeAction: '招待を取り消す',
        tokenTitle: '招待トークン',
        tokenDescription: 'このトークンは一度だけ表示されます。共有または確認が必要なら今すぐコピーしてください。',
        copyToken: 'トークンをコピー',
        tokenCopied: '招待トークンをコピーしました',
        confirmRevokeTitle: '招待を取り消す',
        confirmRevokeDescription: '{{email}} 宛の招待を取り消しますか？',
        columns: {
            email: 'メールアドレス',
            role: 'ロール',
            status: 'ステータス',
            expiresAt: '有効期限',
            createdAt: '作成日',
            actions: '操作',
            actionsDescription: 'この招待に対する操作（取り消しなど）。'
        },
        roles: {
            owner: 'オーナー',
            admin: '管理者',
            member: 'メンバー',
            viewer: '閲覧者'
        },
        statuses: {
            pending: '保留中',
            accepted: '承認済み',
            declined: '辞退済み',
            revoked: '取り消し済み',
            expired: '期限切れ'
        },
        errors: {
            forbidden: 'その招待操作を実行する権限がありません。',
            notFound: 'その招待または組織が見つかりませんでした。',
            conflict: 'その招待操作は招待状態のルールに違反しています。',
            generic: '招待操作に失敗しました。'
        }
    },
    organizationInvitationAcceptance: {
        pageTitle: '組織への招待',
        pageDescription: '招待内容を確認し、必要に応じてサインインして、組織に参加するかどうかを選択してください。',
        preparingAuth: '認証を準備しています…',
        resolving: '招待を確認しています...',
        resolvingDescription: '招待トークンを確認し、招待の詳細を読み込んでいます。',
        invitationDetailsTitle: '招待の詳細',
        invitationDetailsDescription: 'この招待は、サインイン中の招待されたアカウントでのみ承認または辞退できます。',
        fields: {
            organization: '組織',
            role: 'ロール',
            email: '招待先メールアドレス',
            status: 'ステータス'
        },
        unknownOrganization: '不明な組織',
        loginRequiredTitle: 'サインインが必要です',
        loginRequired: 'この招待に応答するには、先にサインインする必要があります。',
        loginAction: 'サインインして招待に応答',
        registerAction: 'アカウントを作成して招待に応答',
        acceptAction: '招待を承認',
        declineAction: '招待を辞退',
        wrongAccountTitle: '別のアカウントでサインインしています',
        wrongAccountDescription:
            'この招待は {{invitedEmail}} 宛ですが、現在 {{currentEmail}} としてサインインしています。一度サインアウトして、招待されたアカウントでサインインし直してください。',
        accepting: '招待を承認しています...',
        acceptingDescription: '組織への参加処理を進めています。',
        declining: '招待を辞退しています...',
        decliningDescription: 'この招待を辞退しています。',
        success: '招待が正常に承認されました。',
        declinedSuccess: '招待を辞退しました。',
        declinedSuccessDescription: '招待は辞退されました。組織に移動します...',
        redirecting: '組織にリダイレクトしています...',
        errorTitle: '招待を処理できませんでした',
        errors: {
            missingToken: 'URL に招待トークンが含まれていません。',
            unauthorized: 'サインインしてから、もう一度招待をお試しください。',
            invalidToken: 'この招待は無効、期限切れ、辞退済み、取り消し済み、またはすでに使用されています。',
            generic: '招待操作に失敗しました。'
        }
    },
    organizationApiKeys: {
        pageTitle: '組織 API キー',
        pageDescription: '{{organizationName}} の API キーを管理します。',
        fallbackOrganizationName: '現在の組織',
        empty: 'この組織には API キーが見つかりません。',
        permissionHint:
            '現在の組織ロールでは API キーを表示できますが、権限レベルにより API キーの作成や取り消しは無効です。',
        subscriptionInactiveDescription:
            '既存の API キーは停止され、新しい API キーはこの組織のサブスクリプションが更新されるまで作成できません。',
        createAction: 'API キーを作成',
        dialogTitle: 'API キーを作成',
        dialogDescription: '組織の API キーを作成し、今すぐトークンをコピーしてください。一度しか表示されません。',
        fields: {
            name: '名前',
            permissions: '権限'
        },
        permissionsDescription: 'この API キーに許可する権限を選択してください。',
        permissionsPublishIncludesRead: '公開権限には読み取り権限も含まれ、自動的に追加されます。',
        permissionsInsightsSeparate:
            '公開権限にはインサイトへのアクセスが含まれなくなりました。公開権限のみの既存キーはインサイトを読み取れません。必要な場合はキー作成時にインサイト読み取り権限を追加してください。',
        permissions: {
            publishing_read: {
                label: '公開データを読む',
                description: '公開リソースと公開済みコンテンツへの読み取り専用アクセスを許可します。'
            },
            publishing_publish: {
                label: 'メディアを公開',
                description: '公開ジョブの作成、およびメディアのアップロードや公開を許可します。'
            },
            insights_read: {
                label: 'インサイトデータを読む',
                description: 'Instagram インサイトデータへの読み取り専用アクセスを許可します。'
            }
        },
        previewAction: 'API キーをプレビュー',
        previewExistingAction: '詳細を表示',
        backToEdit: '編集に戻る',
        previewTitle: 'API キーをプレビュー',
        previewDescription: '作成前に API キーの詳細と権限を確認します。',
        resultTitle: 'API キーを作成しました',
        resultDescription: 'API キートークンを安全にコピーして保管し、その後で保存された詳細と権限を確認してください。',
        previewSummaryTitle: 'API キープレビュー',
        previewSummaryDescription: 'トークンを生成する前にキー名とスコープを確認してください。',
        previewPermissionsDescription: '新しい API キーに付与されるスコープです。',
        previewExistingTitle: 'API キーの詳細',
        previewExistingDescription: '保存済みの API キーメタデータと付与済み権限を確認します。',
        previewExistingLoading: 'API キーの詳細を読み込んでいます...',
        previewExistingEmpty: 'この API キーの詳細は返されませんでした。',
        previewExistingEndpointUnavailable:
            '詳細プレビュー用エンドポイントがまだ利用できないため、このモーダルでは API キー一覧から取得済みのメタデータを表示しています。',
        previewExistingPermissionsDescription: '現在この API キーに付与されているスコープです。',
        previewExistingScopesLoaded: '権限は API キー詳細エンドポイントから読み込まれました。',
        previewExistingNoScopes: 'この API キーにはスコープが返されませんでした。',
        previewExistingTokenAvailable: 'この API キートークンは今表示できます。',
        previewExistingTokenUnavailable: 'この API キーはプレビューできますが、生トークンは表示できません。',
        previewExistingLimitation: 'この API キーのトークン値は利用できません。',
        previewFields: {
            maskedKey: 'マスクされたキー',
            fullKey: '完全な API キー',
            revokedAt: '取り消し日時'
        },
        createSubmit: 'キーを作成',
        creating: 'キーを作成しています...',
        apiKeyCreated: 'API キーを作成しました',
        apiKeyRevoked: 'API キーを取り消しました',
        revokeAction: 'API キーを取り消す',
        tokenTitle: 'API キートークン',
        tokenDescription:
            'このトークンを安全にコピーして保管してください。バックエンドが対応している間は API キー詳細で引き続き表示できる場合があります。',
        copyToken: 'トークンをコピー',
        tokenCopied: 'API キートークンをコピーしました',
        confirmRevokeTitle: 'API キーを取り消す',
        confirmRevokeDescription: 'API キー "{{apiKeyName}}" を取り消しますか？',
        columns: {
            name: '名前',
            status: 'ステータス',
            createdAt: '作成日',
            actions: '操作',
            actionsDescription: 'その公開ジョブのプレビューまたは詳細表示を開きます。'
        },
        statuses: {
            active: '有効',
            revoked: '取り消し済み',
            suspended: '停止中'
        },
        errors: {
            forbidden: 'その API キー操作を実行する権限がありません。',
            notFound: 'その API キーまたは組織が見つかりませんでした。',
            conflict: 'その API キー操作は API キー状態のルールに違反しています。',
            generic: 'API キー操作に失敗しました。'
        }
    },
    organizations: {
        loading: {
            title: '組織を読み込み中',
            description: '組織を取得し、アクティブなコンテキストを選択しています。'
        },
        error: {
            title: '組織を読み込めませんでした',
            description: '組織対応シェルを初期化できませんでした。',
            fallback: '不明な組織エラー'
        },
        subscriptionInactive: {
            title: 'サブスクリプションが無効です',
            actionBlockedToast: 'この操作を使う前に、この組織のサブスクリプションを更新してください。',
            manageBillingAction: '請求を管理',
            ownerHint: '組織のオーナーに請求の更新または再開を依頼してください。'
        },
        limitBanner: {
            cancelEndingTitle: 'サブスクリプションはまもなく終了します',
            cancelEndingDescription:
                'このワークスペースは現在の請求期間の終了時にアクセスを失います。中断を避けるため、請求を更新または修正してください。',
            subscriptionInactiveDescription:
                'このワークスペースでは請求アクセスが無効です。サブスクリプションを更新してフルアクセスを回復してください。',
            trialEndingTitle: 'トライアルはまもなく終了します',
            trialEndingDescription:
                'トライアル期間がまもなく終了します。中断を避けるため、請求情報を追加するか今すぐアップグレードしてください。',
            manageBillingAction: '請求を管理',
            socialAccountsReachedTitle: 'ソーシャルアカウントの上限に達しました',
            socialAccountsReachedDescription:
                '接続済みソーシャルアカウント枠を {{used}} / {{limit}} 使用しています。さらに接続するにはプランをアップグレードしてください。',
            upgradeAction: 'プランをアップグレード',
            socialAccountsWarningTitle: 'ソーシャルアカウント上限に近づいています',
            socialAccountsWarningDescription:
                '接続済みソーシャルアカウント枠を {{used}} / {{limit}} 使用しています。新しい接続がブロックされる前にプランをアップグレードしてください。',
            connectedAccountFallback: 'この接続済みアカウント',
            publishingReachedTitle: '公開枠の上限に達しました',
            publishingReachedDescription:
                '{{accountName}} は現在の請求期間の {{limit}} 件の投稿枠をすべて使い切りました。公開を続けるにはプランをアップグレードしてください。',
            publishingWarningTitle: '公開枠の上限に近づいています',
            publishingWarningDescription:
                '{{accountName}} は現在の請求期間の投稿枠を {{currentUsage}} / {{limit}} 使用しています。公開がブロックされる前にプランをアップグレードしてください。'
        },
        fields: {
            name: '組織名',
            slug: 'スラッグ',
            slugHelp: '任意です。空欄のままにすると、組織名から自動でスラッグが生成されます。'
        },
        create: {
            cta: '組織を作成',
            title: '組織を作成',
            description: '新しい組織を作成し、すぐにその組織に切り替えます。',
            pageTitle: '新しい組織',
            pageDescription: '新しい組織を作成し、すぐに管理を開始します。',
            pageIntro: '新しい組織をセットアップ',
            pageHint: '作成後、新しい組織が自動的にアクティブなコンテキストになり、アプリにリダイレクトされます。',
            sectionTitle: '別の組織を作成',
            sectionDescription: 'Organizations ページから直接新しい組織を作成し、すぐにアクティブにします。',
            hideSection: 'フォームを隠す',
            submit: '作成',
            submitting: '作成しています...',
            success: '組織を作成しました',
            error: '組織の作成に失敗しました',
            conflictError: 'その名前またはスラッグの組織はすでに存在します。',
            validationFallback: 'フォームのエラーを修正して、もう一度お試しください。'
        },
        switcher: {
            label: '組織',
            selectOrganization: '組織を選択',
            loadMore: 'さらに組織を読み込む ({{shown}}/{{total}})',
            loadError: '組織を読み込めませんでした。',
            emptyTitle: 'まだ組織がありません',
            emptyDescription: '最初の組織を作成すると、組織スコープのページが使えるようになります。'
        },
        emptyState: {
            title: '最初の組織を作成',
            description:
                'まだ組織がありません。組織を作成して組織コンテキストを初期化し、組織対応ページを有効にします。'
        },
        onboarding: {
            title: '組織',
            description:
                'ここで最初の組織を作成してください。組織ができると、アプリの他の部分も通常どおり利用できるようになります。',
            createTitle: '最初の組織を作成',
            createDescription: 'ここから開始して、プロダクトの他の部分が依存する組織コンテキストを確立します。',
            workspaceSetupTitle: '組織設定を完了',
            workspaceSetupDescription:
                'まだ組織がないアカウントでも、設定を完了したりプロフィールを管理したりできるように、Organizations と Settings は利用できます。',
            nextStepsTitle: '次に起こること',
            nextStepsDescription: '最初の組織が作成されると、アプリは通常のフローを続行できます。',
            nextStepsCreate: 'デフォルトのコンテキストになる組織を作成してください。',
            nextStepsInvite: '作成後はここに戻ってチームメイトを招待し、組織を拡張できます。',
            nextStepsUnlock: '最初の組織が作成されると、組織スコープのページは自動的に利用可能になります。'
        },
        pageShell: {
            title: '組織',
            description: '組織コンテキスト、作成、今後の管理機能のための専用ホーム。',
            overview: {
                title: '組織',
                description: '現在の組織を確認し、アプリの残りで使うアクティブなコンテキストを選択します。',
                currentState: 'アクティブな組織'
            },
            metrics: {
                totalOrganizations: '組織数',
                activeOrganization: 'アクティブな組織',
                activeRole: 'アクティブなロール',
                noneSelected: '未選択'
            },
            list: {
                count: '{{count}} 組織',
                title: 'あなたの組織',
                description: '所属しているすべての組織を確認し、ここからアクティブなコンテキストを切り替えます。',
                switchAction: 'アクティブにする',
                membershipIdLabel: 'メンバーシップ ID: {{membershipId}}'
            },
            quickActions: {
                title: 'クイックアクション',
                description: '組織フローを 1 か所から開始します。',
                hint: 'このページは、組織のオンボーディングと管理の正式な入り口になります。'
            },
            tabs: {
                title: '組織セクション',
                description: 'アクティブな組織の管理エリアを切り替えます。',
                organizations: '組織',
                members: 'メンバー',
                invitations: '招待',
                membersDescription: 'アクティブな組織のメンバーを管理します。',
                invitationsDescription: 'アクティブな組織の招待を管理します。'
            },
            membersPlaceholder: {
                title: 'メンバーセクションのプレースホルダー',
                description:
                    '専用の Organizations ページが現在の members フローを取り込むと、ここにメンバー管理が表示されます。'
            },
            invitationsPlaceholder: {
                title: '招待セクションのプレースホルダー',
                description:
                    'Organizations ページが現在の invitations フローを取り込むと、ここに招待管理が表示されます。'
            },
            routingNotice:
                'Members と Invitations は現在 Organizations 配下にあります。API Keys は今のところ別のままです。'
        }
    },
    confirmDialog: {
        loading: '読み込み中...'
    },
    oauthConsent: {
        pageTitle: 'アクセスを承認',
        pageDescription: '組織データへのアクセスを許可する前に、このリクエストを確認してください。',
        clientRequestTitle: '{{clientName}} がアクセスを要求しています',
        clientRequestDescription: '承認すると、このアプリは以下の権限であなたの代わりに操作できるようになります。',
        scopesTitle: '要求された権限',
        scopesEmpty: '特定の権限は要求されていません。',
        scopes: {
            mcp: 'MCP へのフルアクセス',
            mcpDescription: 'MCP ゲートウェイを通じた公開およびインサイトツール。'
        },
        expiresAt: 'このリクエストは {{date}} に期限切れになります。',
        organizationTitle: '組織',
        organizationDescription: 'このアプリがアクセスできる組織を選択してください。',
        organizationSingleDescription: 'この組織に対してアクセスが許可されます。',
        organizationsEmptyTitle: '利用可能な組織がありません',
        organizationsEmptyDescription: 'このリクエストを承認するには、少なくとも 1 つの組織が必要です。',
        approve: '承認',
        deny: '拒否',
        approving: '承認中...',
        denying: '拒否中...',
        redirecting: 'リダイレクト中…',
        redirectsTo: '{{url}} にリダイレクトされます。',
        continueToClient: '{{host}} に進む',
        redirectBlocked: 'リダイレクト先が許可されていないため、リダイレクトは行われませんでした。',
        errorTitle: 'このリクエストは完了できません',
        errors: {
            missingRequest: 'URL に同意リクエストの参照がありません。'
        }
    },

    onboardingFlow: {
        placeholderPreviewTitle: 'プレビュー',
        placeholderPreviewDescription: 'ステップ固有のプレビュー内容がここに表示されます。',
        stepPlaceholderDescription:
            '実装は後続のステップ PR で追加されます。このシェル PR はルート、レイアウト、共有状態、ナビゲーションだけを接続します。',
        stepBadge: 'ステップ {{step}}',
        saveFailed: 'オンボーディングの進行状況を保存できませんでした。もう一度お試しください。',
        back: '戻る',
        continue: '続行',
        next: '次へ',
        pricePerMonth: '月額 ${{price}}',
        finish: '完了',
        steps: {
            personalize: 'パーソナライズ',
            connect: '接続',
            activate: '有効化',
            personalizeLabel: '01 · パーソナライズ',
            connectLabel: '02 · 接続'
        },
        shell: {
            breadcrumb: 'オンボーディング',
            help: 'オンボーディングのヘルプを開く',
            counter: 'onboarding · {{current}} / {{total}}'
        },
        personalize: {
            title: 'パーソナライズ',
            description: '何を構築するか教えてください。オンボーディングと組織の初期設定を最適化します。',
            badge: 'ステップ 01 · パーソナライズ',
            heroTitle: '何を構築していますか？',
            goalsTitle: '最初に何をしたいですか？',
            goalsLabel: '// 目標を選択',
            buildModeTitle: 'どのように構築したいですか？',
            buildModeLabel: '// 構築方法',
            sourcesTitle: 'いくつのソースを接続する予定ですか？',
            sourcesLabel: '// 接続するソース',
            sourcesDescription: '2 ソースが含まれています。追加ソースは 1 つあたり月額 $5 です。',
            sourcesHelper: '2 ソース込み、その後は 1 つごとに月額 $5。',
            templatesIncluded: 'すべてのプランに 17 個のスターターテンプレートが含まれます',
            decreaseSources: 'ソース数を減らす',
            increaseSources: 'ソース数を増やす',
            goalSingular: '目標',
            goalPlural: '目標',
            summary: '{{goalCount}} {{goalLabel}} · {{mode}} · {{sources}} ソース · 月額 {{price}}',
            previewEmpty: 'セットアップ概要を表示するには、1 つ以上の目標を選択してください。',
            previewGoals: '選択した目標',
            previewBuildMode: 'ビルドモード',
            previewSources: '申告済みソース: {{count}}',
            previewPrice: '想定価格: {{price}}',
            goals: {
                publish: {
                    label: 'コンテンツを公開',
                    description: '最小限の glue code でコンテンツをチャネルへ配信します。',
                    cardTitle: '公開とスケジュール',
                    cardDescription: 'Reels、カルーセル、ストーリーズを予定どおりに',
                    endpointChip: 'POST /v1/publish/post',
                    recipeTitle: 'コンテンツスケジューラー',
                    recipeDescription: '自分のアプリや DB から reels とカルーセルをキューに入れて自動公開します。'
                },
                comments: {
                    label: 'コメントを管理',
                    description: '返信、トリアージ、モデレーションフローを自動化します。',
                    cardTitle: 'コメントとメンション',
                    cardDescription: '会話が発生した瞬間に取得します',
                    endpointChip: 'GET /v1/read/comments',
                    recipeTitle: 'メンションリスナー',
                    recipeDescription: '誰かがメンションすると webhook が発火し、Slack や CRM に渡せます。'
                },
                analytics: {
                    label: '分析を取得',
                    description: 'アカウントとコンテンツの指標をアプリに取り込みます。',
                    cardTitle: '分析とインサイト',
                    cardDescription: 'リーチ、成長、最適な投稿時間',
                    endpointChip: 'GET /v1/read/analytics',
                    recipeTitle: '分析ダッシュボード',
                    recipeDescription: 'リーチ、成長、最適時間の指標を計算し、DB に取り込みます。'
                },
                ai: {
                    label: 'AI エージェントを構築',
                    description: 'コンテンツツールとエージェント駆動のワークフローを組み合わせます。',
                    cardTitle: 'AI コメント返信',
                    cardDescription: 'ブランドのトーンで返信案を作成 — 承認または自動送信',
                    endpointChip: 'MCP · 返信ツール',
                    recipeTitle: 'コメント返信アシスタント',
                    recipeDescription: 'AI エージェントがブランドトーンで返信案を作成し、承認または自動送信できます。'
                },
                ugc: {
                    label: 'UGC を扱う',
                    description: '承認付きでクリエイターコンテンツを収集・振り分けします。',
                    cardTitle: 'UGC を再投稿',
                    cardDescription: 'タグ付けされたコンテンツを見つけて再投稿します',
                    endpointChip: 'GET /v1/read/mentions',
                    recipeTitle: 'UGC 再投稿ツール',
                    recipeDescription: 'タグ付け投稿の発見、権利リクエスト、再投稿まで一連の流れを自動化します。'
                },
                webhooks: {
                    label: 'Webhook を受け取る',
                    description: 'アカウントや公開ライフサイクルのイベントに反応します。',
                    cardTitle: 'Webhook とイベント',
                    cardDescription: 'コメント、メンション、DM 用の署名付き webhook',
                    endpointChip: 'POST /v1/webhooks',
                    recipeTitle: 'イベントリレー',
                    recipeDescription: 'コメント、メンション、DM ごとに署名付き・再試行ありの webhook を送ります。'
                }
            },
            buildModes: {
                code: {
                    label: 'コードを書く',
                    description: 'API を完全に制御し、直接実装したいです。',
                    summary: 'REST API と SDK'
                },
                agent: {
                    label: 'AI エージェントと一緒に',
                    description: 'エージェントに接続や自動化を手伝ってほしいです。',
                    summary: 'Claude と Cursor 向け MCP'
                },
                both: {
                    label: '両方',
                    description: '必要に応じてエージェント支援を受けつつ、コード中心で進めたいです。',
                    summary: 'コード + エージェント'
                }
            }
        },
        connect: {
            title: 'Instagram を接続',
            description:
                '今すぐ少なくとも 1 つのプロフェッショナル Instagram アカウントを接続するか、スキップしてそのままトライアル checkout に進みます。',
            badge: 'ステップ 02 · 接続',
            headingTitle: '接続',
            headingEmphasis: 'Instagram を接続。',
            headingRest: '今すぐ 1 つのプロアカウントを接続するか、そのまま checkout へ進みます。',
            requirementsLabel: '// 要件',
            afterTrial: 'トライアル後 /月',
            trialBadge: '7 日間無料トライアル',
            completedBadge: 'Checkout 完了',
            connectLaterBadge: 'あとで接続',
            priceStripBreakdown: '{{sources}} ソース · $9 の基本料金に 2 ソース込み',
            priceStripTerms: '7 日間無料 · 0 日目にカード登録 · 8 日目に初回請求',
            skip: '今はスキップ — そのままトライアル checkout へ進む',
            trust: {
                secureTitle: '安全な OAuth のみ',
                secureDescription:
                    'Instagram のパスワードを求めることはありません。Meta 上で直接アクセスを承認します。',
                setupTitle: '公開準備済み',
                setupDescription: 'この接続を使って、組織のスケジューリング、公開、分析を準備します。',
                laterTitle: 'あとで追加可能',
                laterDescription: '今は 1 アカウントだけ接続し、チームの準備ができたら後で追加できます。'
            },
            requirementsTitle: '接続前の要件',
            requirements: {
                professional:
                    'Instagram アカウントは Business または Creator のプロフェッショナルアカウントである必要があります。',
                page: 'その Instagram アカウントは Facebook ページにリンク済みである必要があります。'
            },
            connectionTitle: 'Instagram 接続',
            connectionDescription: 'Meta 経由で Instagram を承認します。リダイレクト後、この画面に戻ります。',
            connectedCounter: '接続済み: {{connected}} / {{sources}}',
            declaredSources: '申告済みソース: {{count}}',
            connected: '接続済み: {{count}}',
            syncedSources: '同期済みソース: {{count}}',
            errorTitle: '接続に失敗しました',
            errors: {
                callbackFailed: 'Instagram アカウントの接続に失敗しました。もう一度お試しください。',
                popupBlocked:
                    'Instagram のログインポップアップがブロックされました。ポップアップを有効にして再試行してください。',
                oauthDenied: 'Instagram の認可は、権限が付与される前にキャンセルされました。',
                personalAccount:
                    'サポートされているのは Instagram のプロフェッショナルアカウントのみです。先に Business または Creator に切り替えてください。',
                missingPage:
                    'この Instagram アカウントは、ここで使う前に Facebook ページへ接続されている必要があります。'
            },
            ctaConnect: 'Instagram アカウントを接続',
            ctaConnectAnother: '別のアカウントを接続',
            ctaConnectShort: 'アカウントを接続',
            ctaConnected: '接続済み',
            ctaWaiting: 'Instagram を待機中…',
            previewTitle: '接続済みアカウント',
            previewDescription: '接続済みアカウント数によって、ソース数が自動的に引き上がる場合があります。',
            previewSourcesNow: '現在のソース数: {{count}}',
            previewEmptyTitle: 'まだ Instagram アカウントが接続されていません',
            previewEmptyDescription: '左側でアカウントを接続すると、オンボーディングの内容がどう埋まるか確認できます。',
            previewNextStep: '次のステップ',
            previewActivate: '無料トライアルを有効化',
            previewRequirementsLink: 'Instagram の要件を確認',
            previewSyncedMessage: '共有ステートによりソース数が自動同期されます。現在の申告済みソース: {{count}}',
            checkoutCanceled: 'Checkout はキャンセルされました。オンボーディング状態は保持されています。',
            checkoutUnavailable:
                'チェックアウトはまだ利用できません。課金プロダクトが設定されていません。後でもう一度お試しください。',
            finalizingTitle: 'サブスクリプションを確定しています',
            finalizingDescription: 'Stripe によるチェックアウトの確認を待っています。通常は数秒で完了します。',
            checkoutTitle: 'トライアル料金',
            checkoutDescription: 'もう独立した Step 3 はありません。この画面から直接 checkout が始まります。',
            checkoutCta: '{{days}} 日間の無料トライアルを開始',
            nextToDashboard: 'ダッシュボード welcome state へ',
            previewConnectLater: '必要なら後で dashboard から接続できます。',
            previewTrialDetailsTitle: 'トライアル詳細',
            previewTrialDetails:
                '0 日目: カード取得。8 日目: 初回請求。成功すると dashboard welcome state に遷移します。'
        },
        activate: {
            title: '組織を有効化',
            description:
                '無料トライアルを開始し、ソース数を確認して、セットアップをダッシュボードのウェルカム状態へ引き渡します。',
            trialActivatedTitle: 'トライアルが有効化されました',
            trialActivatedDescription:
                '組織の準備ができました。ダッシュボードのウェルカム状態が、目標・接続状況・{{count}} ソースのプランを引き継ぐはずです。',
            waitingCards: {
                connectionTitle: 'Instagram 接続',
                connectionDescription:
                    '接続をスキップした場合でも、ダッシュボードのウェルカムチェックリストから後で完了できます。',
                workspaceTitle: '組織の仕上げ',
                workspaceDescription:
                    'ソース、目標、アクティベーション概要は checkout 後の welcome state に引き継がれます。'
            },
            nextToDashboard: 'ダッシュボード welcome state へ',
            startTrial: '{{days}} 日間の無料トライアルを開始',
            cancelBannerTitle: 'Checkout がキャンセルされました',
            cancelBannerDescription: 'トライアルは開始されませんでした。ここで設定した内容は保持されています。',
            badge: 'ステップ 3 · 有効化',
            heroTitle: '{{days}} 日間の無料トライアルを有効化',
            heroDescription:
                'まだ実際の請求は行われません。これは Stripe のモック handoff で、リダイレクト・キャンセル・成功の間もオンボーディング状態を保持します。',
            postTrialPrice: 'トライアル後の価格',
            chargedStarting: '{{day}} 日目から請求',
            trust: {
                startToday: '今日から {{days}} 日間の無料トライアルを開始',
                cardRequired: '組織を有効化するにはカードが必要です',
                noCharge: '{{day}} 日目までは請求されません'
            },
            priceBreakdownTitle: '価格内訳',
            priceBreakdownDescription:
                'トライアル開始前にソース数を調整できます。価格ロジックは共有ヘルパーを使います。',
            sourcesTitle: 'ソース',
            sourcesDescription: 'このセットアップでは最低 {{count}} ソースを使用してください。',
            baseLabel: '基本料金 ({{count}} ソース)',
            baseDetail: '追加料金前の基本分に含まれます',
            additionalLabel: '追加ソース',
            additionalDetailNone: '追加ソースは選択されていません',
            additionalDetailSome: '{{count}} × ${{price}}',
            monthlyAfterTrialLabel: 'トライアル後の月額',
            monthlyAfterTrialDetail: 'トライアル終了後に請求される正確な金額',
            breakdownIncluded: '{{count}} ソースが ${{price}} の基本料金に含まれます',
            breakdownExpanded: '${{base}} の基本料金 + {{extraCount}} × ${{extraPrice}}',
            stripeHandoffTitle: 'Stripe モック handoff',
            stripeHandoffDescription:
                '実際の請求を行わずに、リダイレクト・キャンセル・成功をモック状態で確認できます。',
            stripeReady: '開始可能',
            stripeRedirecting: 'Stripe へリダイレクト中…',
            redirectTitle: 'Stripe Checkout へリダイレクト中',
            redirectDescription:
                '本番ではここで Stripe がカード情報を受け取り、アプリに戻します。今はモック結果を選んでください。',
            simulateCancel: 'キャンセル戻りをシミュレート',
            simulateSuccess: '成功した checkout をシミュレート',
            stripeCtaNote:
                'この CTA はモック Stripe セッションを開始し、戻り処理でもオンボーディング状態を保持します。',
            recapTitle: 'セットアップ概要',
            recapHeading: '有効化の準備完了',
            recapGoals: '選択した目標',
            recapInstagram: 'Instagram',
            recapSources: 'ソース',
            recapTrialDetails: 'トライアル詳細',
            recapAfterCheckout: 'checkout 後',
            recapNoneYet: 'まだありません',
            recapConnected: '{{count}} 接続済み',
            recapSkipped: 'まだ未接続 — 今はスキップ',
            recapNotConnected: 'まだ接続されていません',
            recapSourcesValue: '{{count}} ソース · トライアル後 {{price}}',
            recapTrialValue: '{{days}} 日間無料 · カード必須 · {{day}} 日目までは請求なし',
            recapAfterCheckoutPending: 'checkout 成功後、この概要はダッシュボードの welcome state に渡されます。',
            recapAfterCheckoutComplete: 'この概要を持ったままユーザーをダッシュボードの welcome state へ送ります。',
            expectedPriceTitle: 'トライアル後の想定月額'
        }
    },
    pricing: {
        pageTitle: '料金',
        pageDescription: 'アプリ全体の体験に合った、わかりやすいソース単位の料金設定です。',
        eyebrow: '料金',
        calculatorTitle: '料金を計算',
        calculatorDescription: '必要なソース数を選ぶと、月額合計がすぐに更新されます。',
        accountsLabel: 'ソース',
        accountsIncludedLabel: 'プランに含まれるソース数',
        minAccounts: '{{count}} ソース',
        maxAccounts: '{{count}} ソース',
        firstTierLabel: '最初の {{count}} ソース',
        firstTierRate: '{{price}} / {{count}} ソース',
        additionalAccountsLabel: '追加ソース',
        additionalAccountsRate: '追加ソース 1 件ごとに {{price}}',
        monthlyTotalLabel: '月額合計',
        monthlyOnlyHint: 'リアルタイム見積もり、月額請求',
        customSolutionTitle: '個別プランが必要ですか？',
        customSolutionDescription: 'より大きな利用規模向けの料金や導入支援が必要な場合はお問い合わせください。',
        trialTitle: '7日間の無料トライアル',
        trialDescription: 'まず 7 日間の無料トライアルを開始し、その後は同じ月額・数量ベースのプランを継続します。',
        checkoutCta: 'Stripe でトライアルを開始',
        requiresOrganization: 'チェックアウトを開始する前に、組織を作成または選択してください。',
        checkoutForOrganization: '{{organizationName}} 向けに、選択した数量でチェックアウトを開始します。',
        manageSubscriptionCta: 'サブスクリプションを管理',
        alreadySubscribed:
            '{{organizationName}} には既に有効なサブスクリプションがあります。ソース数は設定から変更してください。',
        contactCta: 'お問い合わせ',
        planTitle: 'あなたのプラン',
        planDescription: '{{count}} ソースを含み、それ以降は追加ソースごとに固定料金がかかる明確な月額料金です。',
        month: '月',
        accountsSelected: '{{count}} ソースを選択中',
        planFirstTierLine: '最初の {{count}} ソースを含む',
        planTierCalculation: '{{price}} × {{count}}',
        includedLabel: '含まれる機能',
        primaryCta: '始める',
        monthlyOnlyDisclaimer: '月額料金のみです。クレジット制や年額課金の前提はありません。',
        features: {
            organizations: '組織、メンバー、招待の管理',
            socialAccounts: '接続済みソーシャルアカウント',
            publishing: '投稿公開ワークフロー',
            insights: 'Instagram インサイト',
            apiKeys: '組織の API キー',
            customerSupport: 'カスタマーサポート'
        }
    },
    apiErrors: {
        auth: {
            required: '認証が必要です。',
            invalidOrExpiredToken: '認証が必要です。セッションが無効または期限切れの可能性があります。'
        },
        validation: {
            invalidRequestBody: 'リクエストが無効です。入力内容を確認して、もう一度お試しください。',
            required: 'この項目は必須です。',
            emailInvalid: '有効なメールアドレスを入力してください。',
            stringMaxLength: 'この値は長すぎます。'
        },
        organizations: {
            invalidRequest: '組織リクエストが無効です。',
            conflict: '同じ情報を持つ組織がすでに存在します。',
            notFound: '組織が見つかりませんでした。',
            loadFailed: '組織を読み込めませんでした。',
            createFailed: '組織を作成できませんでした。',
            validation: {
                nameMaxLength: '組織名が長すぎます。',
                slugMaxLength: '組織スラッグが長すぎます。',
                slugFormat: '組織スラッグには小文字、数字、ハイフンのみ使用できます。'
            }
        },
        onboarding: {
            updateForbidden: '組織のオーナーと管理者のみがオンボーディングを更新できます。',
            validation: {
                goalsRequiredBeforeConnect: '接続へ進む前にオンボーディング目標を少なくとも1つ選択してください。'
            }
        },
        billing: {
            invalidRequest: '請求リクエストが無効です。',
            manageForbidden: 'この組織の請求を管理する権限がありません。',
            organizationNotFound: '組織が見つかりませんでした。',
            organizationOrProductNotFound: '組織または請求プロダクトが見つかりませんでした。',
            incompleteConfiguration: 'このチェックアウトフローに必要な請求設定がまだ不完全です。',
            lifetimeSubscriptionActive:
                'この組織はライフタイムプランのため、Stripe による請求は利用できません。プランを変更する場合は invisibleapi までご連絡ください。',
            integration: '請求プロバイダーで連携エラーが発生しました。',
            productsLoadFailed: '請求プランを読み込めませんでした。',
            stateLoadFailed: '組織の請求状態を読み込めませんでした。',
            checkoutFailed: 'チェックアウトセッションを作成できませんでした。',
            customerPortalFailed: 'カスタマーポータルを開けませんでした。',
            validation: {
                successUrlInvalid: '請求の成功 URL が無効です。',
                cancelUrlInvalid: '請求のキャンセル URL が無効です。',
                returnUrlInvalid: '請求の戻り先 URL が無効です。'
            }
        },
        userProfile: {
            loadFailed: 'アカウント詳細を読み込めませんでした。',
            updateFailed: 'アカウント詳細を保存できませんでした。',
            actionEmailFailed: 'アカウントのセキュリティメールをリクエストできませんでした。',
            accountServiceUnavailable: 'アカウントサービスは現在リクエストを完了できません。',
            notFound: 'アカウントプロフィールが見つかりませんでした。',
            updateRejected: 'アカウントサービスがアカウント詳細の更新を拒否しました。',
            actionRejected: 'アカウントサービスがセキュリティメールのリクエストを拒否しました。',
            validation: {
                readOnly: 'この項目は読み取り専用です。',
                unsupported: 'この項目はサポートされていません。'
            }
        },
        organizationInvitations: {
            listForbidden: 'この組織の招待を表示する権限がありません。',
            createForbidden: 'この組織にメンバーを招待する権限がありません。',
            revokeForbidden: 'この組織の招待を取り消す権限がありません。',
            createConflict: '組織の招待ルールに違反するため、この招待は作成できません。',
            revokeConflict: '現在の状態では、この招待を取り消せません。',
            notFound: '組織または招待が見つかりませんでした。',
            invalidToken: 'この招待は無効、期限切れ、取り消し済み、またはすでに使用されています。',
            actionFailed: '招待アクションを完了できませんでした。'
        },
        organizationMembers: {
            listForbidden: 'この組織のメンバーを表示する権限がありません。',
            removeForbidden: 'このメンバーを削除する権限がありません。',
            removeConflict: '組織のメンバーシップルールに違反するため、このメンバーは削除できません。',
            updateForbidden: 'このメンバーを更新する権限がありません。',
            updateConflict: 'このメンバーのロール変更は組織のメンバーシップルールに違反します。',
            actionFailed: 'メンバーアクションを完了できませんでした。',
            validation: {
                roleInvalid: '選択された組織ロールが無効です。'
            }
        },
        organizationApiKeys: {
            listForbidden: 'この組織の API キーを表示する権限がありません。',
            manageForbidden: 'この組織の API キーを管理する権限がありません。',
            notFound: '組織または API キーが見つかりませんでした。',
            createConflict: '組織の API キールールに違反するため、この API キーは作成できません。',
            revokeConflict: '現在の状態では、この API キーを取り消せません。',
            actionFailed: 'API キーアクションを完了できませんでした。',
            validation: {
                nameMaxLength: 'API キー名が長すぎます。'
            }
        },
        socialAccounts: {
            listFailed: 'ソーシャルアカウントを読み込めませんでした。',
            connectFailed: 'ソーシャルアカウント接続を開始できませんでした。',
            reconnectFailed: 'ソーシャルアカウントの再接続を開始できませんでした。',
            disconnectFailed: 'ソーシャルアカウントを切断できませんでした。',
            forbidden: 'この組織のソーシャルアカウントを管理する権限がありません。',
            notFound: '組織またはソーシャルアカウントが見つかりませんでした。',
            conflict: '現在の状態では、このソーシャルアカウント操作を完了できませんでした。'
        },
        publishing: {
            listFailed: '公開ジョブを読み込めませんでした。',
            detailFailed: '公開ジョブの詳細を読み込めませんでした。',
            createFailed: '公開ジョブを作成できませんでした。',
            paidPlanLimitExceeded: '有料プランの公開上限に達しました。',
            paidPlanLimitExceededForAccount: '{{account}} の公開上限に達しました。',
            paidPlanLimitExceededUnknownAccount: '選択したアカウント',
            paidPlanLimitExceededUsageDetails:
                '現在の使用量: {{currentUsage}}/{{limit}}。有効な予約: {{activeReservations}}。リクエストされた投稿数: {{requestedCount}}。',
            paidPlanLimitExceededResetDetails: '{{resetAt}} 以降にもう一度お試しください。',
            forbidden: 'この組織の公開を管理する権限がありません。',
            notFound: '組織または公開ジョブが見つかりませんでした。',
            conflict: '現在の公開制約により、この公開リクエストを完了できませんでした。',
            validation: {
                mediaUrlUnreachable:
                    'メディアURLにアクセスできませんでした。メディアファイルへの公開された直接リンクを指定してください。',
                mediaUrlHttpError: 'メディアURLがメディアファイルを返さず、エラーを返しました。',
                mediaUrlNotImage:
                    'このURLは画像ファイルを指していません。ウェブページではなく、画像への直接リンク（例：.jpgのURL）を指定してください。',
                mediaUrlNotVideo:
                    'このURLは動画ファイルを指していません。ウェブページではなく、動画への直接リンク（例：.mp4のURL）を指定してください。'
            }
        },
        oauthConsent: {
            loadFailed: '同意リクエストを読み込めませんでした。',
            approveFailed: '同意リクエストを承認できませんでした。',
            denyFailed: '同意リクエストを拒否できませんでした。',
            invalidRequest: '同意リクエストが無効です。',
            forbidden: '選択した組織に対してこのリクエストを承認する権限がありません。',
            notFound: 'この同意リクエストは不明か、期限切れか、すでに処理されています。'
        },
        insights: {
            loadFailed: 'インサイトを読み込めませんでした。',
            invalidQuery: 'インサイトのクエリが無効です。指標・期間・パラメータの組み合わせを確認してください。',
            forbidden: 'この組織のインサイトを表示する権限がありません。',
            notFound: '組織またはソーシャルアカウントが見つかりませんでした。',
            notReadable: 'このアカウントは現在インサイトを取得できません。インサイト権限を付与して再接続してください。',
            providerRejected:
                'Instagramがこのインサイトリクエストを拒否しました。指定した指標の組み合わせがこのアカウントでサポートされていない可能性があります。'
        }
    },
    validation: {}
} as const;
